import client from '@/graphql/client'
import GetAiAttachmentUploadUrl from '@/graphql/mutations/GetAiAttachmentUploadUrl'
import DeleteAiAttachmentFile from '@/graphql/mutations/DeleteAiAttachmentFile'

// AI attachments are stored under ai-attachments/{projectId}/{workflowId}/{id}/{filename},
// so the projectId is the second path segment.
const projectIdFromKey = (s3Key) => (s3Key || '').split('/')[1]

// Upload via a server-minted, org-membership-gated presigned PUT URL (the key is
// built server-side; the browser holds no S3 credentials).
export const uploadAiAttachment = async ({ projectId, workflowId, file, mimeType }) => {
  const { getAiAttachmentUploadUrl } = await client.query({
    operationName: 'getAiAttachmentUploadUrl',
    query: GetAiAttachmentUploadUrl,
    variables: { projectId, workflowId, filename: file.name }
  })
  const { url, key } = getAiAttachmentUploadUrl
  await fetch(url, { method: 'PUT', body: file })

  return {
    s3Key: key,
    name: file.name,
    mimeType,
    size: file.size
  }
}

// Delete via a server-side, gated mutation (AI attachments have no DB record /
// stream cascade, so the file is removed directly after the access check).
export const deleteAiAttachment = async (s3Key) => {
  await client.query({
    operationName: 'deleteAiAttachmentFile',
    query: DeleteAiAttachmentFile,
    variables: { projectId: projectIdFromKey(s3Key), key: s3Key }
  })
}
